/**
 * Demo stubs for onboardingChecklistApi methods.
 * Returns safe empty/success responses to prevent crashes in demo mode.
 */
export const demoOnboardingService = {
  getTemplates: async () => ({ templates: [], categories: [], total: 0 }),
  createTemplate: async () => ({ id: 1, category: 'document', title: 'Demo', order_index: 0, is_active: true }),
  updateTemplate: async () => ({ id: 1, category: 'document', title: 'Demo', order_index: 0, is_active: true }),
  deleteTemplate: async () => undefined,
  getEmployeeTasks: async () => ({ employee_id: '', tasks: [], total: 0, progress: { completed: 0, total: 0, percent: 0 } }),
  initializeEmployeeTasks: async () => ({ employee_id: '', tasks: [], total: 0 }),
  updateTask: async () => ({ id: 1, status: 'pending', template_id: 1 }),
  getSummary: async () => ({ total_employees: 0, completed: 0, in_progress: 0, not_started: 0, employees: [] }),
};
